import type { AiCostLimitLevel } from '@Domain/AiCostLimits/AiCostLimitLevel';
import type { AiCostLimitState } from '@Domain/AiCostLimits/AiCostLimitState';

export type AiCostLimitAlertPayload = {
	readonly limitId: number;
	readonly level: { readonly value: AiCostLimitLevel; readonly label: string };
	readonly subjectId: number;
	readonly state: { readonly value: AiCostLimitState; readonly label: string };
	readonly percent: number;
};

export type AiCostLimitAlertsFetchedAction = {
	type: 'AI_COST_LIMIT_ALERTS_FETCHED';
	payload: AiCostLimitAlertPayload[];
	accountId: number;
};

export default (payload: AiCostLimitAlertPayload[], accountId: number): AiCostLimitAlertsFetchedAction => ({
	type: 'AI_COST_LIMIT_ALERTS_FETCHED',
	payload,
	accountId,
});
